<div id="layout" class="theme-cyan">
  <app-event-leftmenu></app-event-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body: -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Message</h5>
                  </div>
                  <small class="text-truncate text-muted">(last update 1hr ago)</small>
                </div>
              </div>
            </div>

            <!-- page action  -->
            <div class="col-7 col-xl-8 text-end">
              <ul class="nav justify-content-end d-inline-flex">
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" (click)="isCollapsed = !isCollapsed"
                    [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic" title="Search this chat">
                    <i class="zmdi zmdi-search zmdi-hc-lg"></i>
                  </a>
                </li>
              </ul>
            </div>

          </div>

        </div>
      </div>

      <!-- Body: Search -->
      <div class="collapse" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
        <div class="container-fluid py-2">

          <div class="row">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search...">
              <div class="input-group-append">
                <span class="input-group-text text-muted"><small>0 / 0</small></span>
              </div>
              <div class="input-group-append dropdown" dropdown placement="bottom right">
                <button type="button" class="btn btn-secondary">Search</button>


                <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                  class="btn btn-secondary dropdown-toggle dropdown-toggle-split ml-1">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  aria-labelledby="button-basic">
                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                  <div role="separator" class="dropdown-divider"></div>
                  <a class="dropdown-item" href="javascript:void(0)">Separated link</a>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container">

          <div class="row">
            <div class="col-lg-12 col-md-12">
              <div class="card mb-1 bg-dark">
                <ul class="nav nav-tabs page-header-tabs px-3 pt-3" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link active" id="inbox-tab" href="javascript:void(0)" (click)="onMenuTab('1')"
                      [ngClass]="{'active': inboxTab}">
                      <span class="d-block d-md-none"><i class="zmdi zmdi-email"></i></span>
                      <span class="d-none d-md-block h6">INBOX</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="sent-tab" href="javascript:void(0)" (click)="onMenuTab('2')"
                      [ngClass]="{'active': sentTab}">
                      <span class="d-block d-md-none"><i class="zmdi zmdi-mail-send"></i></span>
                      <span class="d-none d-md-block h6">SENT</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="spam-tab" href="javascript:void(0)" (click)="onMenuTab('3')"
                      [ngClass]="{'active': spamTab}">
                      <span class="d-block d-md-none"><i class="zmdi zmdi-block"></i></span>
                      <span class="d-none d-md-block h6">SPAM</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="delete-tab" href="javascript:void(0)" (click)="onMenuTab('4')"
                      [ngClass]="{'active': deleteTab}">
                      <span class="d-block d-md-none"><i class="zmdi zmdi-delete"></i></span>
                      <span class="d-none d-md-block h6">DELETED</span>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="card mb-4">
                <div class="tab-content">
                  <div class="tab-pane fade active show" id="inbox" [ngClass]="{'show active': inboxTab}">
                    <div class="row p-4 no-gutters align-items-center border-bottom">
                      <div class="col-sm-12 col-md-6">
                        <h4 class=" mb-0">145 Unread emails</h4>
                      </div>
                      <div class="col-sm-12 col-md-6 text-end">
                        <div class="btn-group">
                          <button type="button" class="btn btn-primary" (click)="openModal(template)">Compose</button>
                          <button type="button" class="btn btn-danger">Delete</button>
                        </div>
                      </div>
                    </div>
                    <!-- Mail list-->
                    <div class="list-group custom list-group-flush mail-list-widget">
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star"></i></div>
                          <div class="px-1 text-truncate user-name">Terry Carter</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-primary me-1">Work</span>
                              <span class="text-muted">Lorem ipsum perspiciatis</span>
                            </a>
                          </div>
                          <div class="date"><small>Dec 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Michelle Green</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-primary me-1">Business</span>
                              <span class="text-muted">Regarding our meeting – There are many variations of
                                passages</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>Dec 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star"></i></div>
                          <div class="px-1 text-truncate user-name">Jason Porter</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-success me-1">Friend</span>
                              <span class="text-muted">Hey, You wanna join me and Fred at the lake tomorrow?</span>
                            </a>
                          </div>
                          <div class="date"><small>Nov 16</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">David Wallace</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-warning me-1">Domain</span>
                              <span class="text-muted">Lorem ipsum perspiciatis</span>
                            </a>
                          </div>
                          <div class="date"><small>Nov 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Grace Knight</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-info me-1">HR</span>
                              <span class="text-muted">There are many variations of passages of Lorem Ipsum
                                available</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>Aug 18</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star"></i></div>
                          <div class="px-1 text-truncate user-name">Terry Carter</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-danger me-1">Support</span>
                              <span class="text-muted">Hello - That's great, see you on Thursday!</span>
                            </a>
                          </div>
                          <div class="date"><small>Aug 11</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star"></i></div>
                          <div class="px-1 text-truncate user-name">Terry Carter</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-primary me-1">Work</span>
                              <span class="text-muted">Lorem ipsum perspiciatis</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>Aug 9</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Michelle Green</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-primary me-1">Business</span>
                              <span class="text-muted">Regarding our meeting – There are many variations of
                                passages</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>Jun 23</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star"></i></div>
                          <div class="px-1 text-truncate user-name">Jason Porter</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-success me-1">Friend</span>
                              <span class="text-muted">Hey, You wanna join me and Fred at the lake tomorrow?</span>
                            </a>
                          </div>
                          <div class="date"><small>Jun 22</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">David Wallace</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-warning me-1">Domain</span>
                              <span class="text-muted">Lorem ipsum perspiciatis</span>
                            </a>
                          </div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="sent" [ngClass]="{'show active': sentTab}">
                    <div class="row p-4 no-gutters align-items-center border-bottom">
                      <div class="col-sm-12 col-md-6">
                        <h4 class=" mb-0">78 emails</h4>
                      </div>
                      <div class="col-sm-12 col-md-6 text-end">
                        <div class="btn-group">
                          <button type="button" class="btn btn-primary" (click)="openModal(template)">Compose</button>
                          <button type="button" class="btn btn-danger">Delete</button>
                        </div>
                      </div>
                    </div>

                    <!-- Mail list-->
                    <div class="list-group custom list-group-flush mail-list-widget">
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Terry Carter</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-primary me-1">Work</span>
                              <span class="text-muted">Lorem ipsum perspiciatis</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star"></i></div>
                          <div class="px-1 text-truncate user-name">Michelle Green</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-primary me-1">Business</span>
                              <span class="text-muted">Regarding our meeting – There are many variations of
                                passages</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Jason Porter</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-success me-1">Friend</span>
                              <span class="text-muted">Hey, You wanna join me and Fred at the lake tomorrow?</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star"></i></div>
                          <div class="px-1 text-truncate user-name">David Wallace</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-warning me-1">Domain</span>
                              <span class="text-muted">Lorem ipsum perspiciatis</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Grace Knight</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-info me-1">HR</span>
                              <span class="text-muted">There are many variations of passages of Lorem Ipsum
                                available</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Terry Carter</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-danger me-1">Support</span>
                              <span class="text-muted">Hello - That's great, see you on Thursday!</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="spam" [ngClass]="{'show active': spamTab}">
                    <div class="row p-4 no-gutters align-items-center border-bottom">
                      <h3>No spam eamil</h3>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="delete" [ngClass]="{'show active': deleteTab}">
                    <div class="row p-4 no-gutters align-items-center border-bottom">
                      <div class="col-sm-12 col-md-6">
                        <h4 class=" mb-0"><i class="me-2"></i>78 emails</h4>
                      </div>
                      <div class="col-sm-12 col-md-6 text-end">
                        <div class="btn-group">
                          <button type="button" class="btn btn-primary" (click)="openModal(template)">Compose</button>
                          <button type="button" class="btn btn-danger">Delete</button>
                        </div>
                      </div>
                    </div>

                    <!-- Mail list-->
                    <div class="list-group custom list-group-flush mail-list-widget">
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Terry Carter</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-primary me-1">Work</span>
                              <span class="text-muted">Lorem ipsum perspiciatis</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Michelle Green</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-primary me-1">Business</span>
                              <span class="text-muted">Regarding our meeting – There are many variations of
                                passages</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Jason Porter</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-success me-1">Friend</span>
                              <span class="text-muted">Hey, You wanna join me and Fred at the lake tomorrow?</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">David Wallace</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-warning me-1">Domain</span>
                              <span class="text-muted">Lorem ipsum perspiciatis</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Grace Knight</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-info me-1">HR</span>
                              <span class="text-muted">There are many variations of passages of Lorem Ipsum
                                available</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action py-md-3 py-2">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Terry Carter</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-danger me-1">Support</span>
                              <span class="text-muted">Hello - That's great, see you on Thursday!</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>

<ng-template #template>
  <div class="modal-header">
    <h5 class="modal-title pull-left" style="font-family: 'IBM Plex Sans', sans-serif;">New Message
    </h5>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="font-family: 'IBM Plex Sans', sans-serif;">
    <form class="row">
      <div class="col-12">
        <div class="form-group mb-1">
          <div class="input-group">
            <input type="text" class="form-control form-control-lg" placeholder="To:">
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <div class="input-group">
            <input type="text" class="form-control form-control-lg" placeholder="CC:">
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <div class="input-group">
            <input type="text" class="form-control form-control-lg" placeholder="Subject">
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <div class="input-group">
            <textarea rows="4" class="form-control" placeholder="Enter Bio"></textarea>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <label>Select Attachment</label>
          <input type="file" class="form-control-file">
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer" style="font-family: 'IBM Plex Sans', sans-serif;">
    <button type="button" class="btn btn-secondary" (click)="modalRef.hide()"
      style="background-color: #00028C;">Close</button>
    <button type="button" class="btn btn-primary" style="background-color: #21AA93;">Send</button>
  </div>

</ng-template>
